export const messages = {
  en: {
    common: {
      search: 'Search',
      reset: 'Reset',
      operation: 'Operation',
      edit: 'Edit',
      add: 'Add',
      addChild: 'AddChild',
      view: 'View',
      delete: 'Delete',
      confirm: 'Confirm',
      cancel: 'Cancel',
      none: 'None',
      close: 'Close',
      back: 'Back',
      warning: 'Warning',
      deleteConfirm: 'Are you sure to delete this record?',
      confirmDelete: 'confirm delete',
      confirmExit: 'confirm exit',
      deleteSuccess: 'Delete successfully',
      selectBtn: 'Select',
      select: 'Select',
      submit: 'Submit',
      upload: 'Upload',
      chooseDate: 'Choose Date',
      download: 'Download',
      queryCondition: 'Query Condition',
      detail: 'Detail',
      save: 'Save',
      update: 'Update',
      createTime: 'Create Time',
      document: 'Document',
      resetPwdSuccess: 'Reset password successfully, new password is {pwd}, please change it in time',
      female: 'Female',
      male: 'Male',
      all: 'All',
      refresh: 'Refresh',
      export: 'Export',
      query: 'Query',
      yes: 'Yes',
      no: 'No',
      status: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      import: 'Import',
      remark: 'Remark',
      hour: 'hour',
      more: 'More',
      tip: 'Tip',
      selectFile: 'Select File',
      change: 'Change',
      print: 'Print',
      year: 'Year',
      month: 'Month',
      examine: 'Examine',
      audit: 'Audit',
      choose: 'Choose',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed',
      saveSuccess: 'successfully',
      operateSuccess: 'Operate successfully',
      operateFailed: 'Operate failed',
      noData: 'No Data',
      file: 'File',
      hide: 'Hide',
      viewDetail: 'View Detail',
      yuan: 'yuan',
      process: 'Process',
      jpgOnly: 'Only JPG files are allowed',
      sizeLimit: 'File size must be less than 2MB',
      required: 'Required',
      invalid: 'Invalid',
      valid: 'Valid',
      pleaseSelect: 'Please Select',
      manage: 'Manage',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      map: 'Map',
      remove: 'Remove',
      operationSuccess: 'Operation successfully',
    }
  },
  zh: {
    common: {
      search: '搜索',
      reset: '重置',
      operation: '操作',
      edit: '编辑',
      add: '添加',
      addChild: '添加',
      view: '查看',
      delete: '删除',
      confirm: '确定',
      cancel: '取消',
      none: '无',
      close: '关闭',
      back: '返回',
      warning: '警告',
      deleteConfirm: '确定要删除这条记录吗？',
      confirmDelete: '确定删除',
      confirmExit: '确定退出',
      deleteSuccess: '删除成功',
      selectBtn: '选择',
      select: '选择',
      submit: '提交',
      upload: '上传',
      chooseDate: '选择日期',
      download: '下载',
      queryCondition: '查询条件',
      detail: '详情',
      save: '保存',
      update: '更新',
      createTime: '创建时间',
      document: '文档',
      resetPwdSuccess: '修改密码成功，密码为{pwd}请及时修改密码',
      female: '女',
      male: '男',
      all: '全部',
      refresh: '刷新',
      export: '导出',
      query: '查询',
      yes: '是',
      no: '否',
      status: '状态',
      enabled: '启用',
      disabled: '禁用',
      import: '导入',
      remark: '备注',
      hour: '时',
      more: '更多',
      tip: '提示',
      selectFile: '选择文件',
      change: '变更',
      print: '打印',
      year: '年',
      month: '月',
      examine: '审核',
      audit: '审核',
      choose: '选择',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      saveSuccess: '成功',
      operateSuccess: '操作成功',
      operateFailed: '操作失败',
      noData: '暂无数据',
      file: '附件',
      hide: '隐藏',
      viewDetail: '查看详情',
      yuan: '元',
      process: '处理',
      jpgOnly: '只允许上传JPG文件',
      sizeLimit: '文件大小必须小于2MB',
      required: '必填',
      invalid: '无效',
      valid: '有效',
      pleaseSelect: '请选择',
      manage: '管理',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      map: '地图',
      remove: '删除',
      operationSuccess: '操作成功',
    }
  },
  'zh-TW': {
    common: {
      search: '搜尋',
      reset: '重設',
      operation: '操作',
      edit: '編輯',
      add: '添加',
      addChild: '添加',
      view: '查看',
      delete: '刪除',
      confirm: '確定',
      cancel: '取消',
      none: '無',
      close: '關閉',
      back: '返回',
      warning: '警告',
      deleteConfirm: '確定要刪除這條記錄嗎？',
      confirmDelete: '確定刪除',
      confirmExit: '確定退出',
      deleteSuccess: '刪除成功',
      selectBtn: '選擇',
      select: '選擇',
      submit: '提交',
      upload: '上傳',
      chooseDate: '選擇日期',
      download: '下載',
      queryCondition: '查詢條件',
      detail: '詳情',
      save: '保存',
      update: '更新',
      createTime: '創建時間',
      document: '文檔',
      resetPwdSuccess: '修改密碼成功，密碼為{pwd}請及時修改密碼',
      female: '女',
      male: '男',
      all: '全部',
      refresh: '刷新',
      export: '匯出',
      query: '查詢',
      yes: '是',
      no: '否',
      status: '狀態',
      enabled: '啟用',
      disabled: '停用',
      import: '匯入',
      remark: '備註',
      hour: '時',
      more: '更多',
      tip: '提示',
      selectFile: '選擇文件',
      change: '變更',
      print: '列印',
      year: '年',
      month: '月',
      examine: '審核',
      audit: '審核',
      choose: '選擇',
      submitSuccess: '提交成功',
      submitFailed: '提交失敗',
      saveSuccess: '成功',
      operateSuccess: '操作成功',
      operateFailed: '操作失敗',
      noData: '暫無數據',
      file: '附件',
      hide: '隱藏',
      viewDetail: '查看詳情',
      yuan: '元',
      process: '處理',
      jpgOnly: '只允許上傳JPG文件',
      sizeLimit: '文件大小必須小於2MB',
      required: '必填',
      invalid: '無效',
      valid: '有效',
      pleaseSelect: '請選擇',
      manage: '管理',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      map: '地圖',
      remove: '刪除',
      operationSuccess: '操作成功',
    }
  }
}